import React, { useState } from 'react';
import propTypes from 'prop-types';

import { Card, CardContent, Columns, Column } from 'src/ui/mui-ui-kit';
import {
  SaveChangesToast,
  ConfirmChangesModal,
  UiFieldset,
  UiInputAdapter,
  UiToggleAdapter,
  InnerLoader,
  UiSelectAdapter,
  UiQuillAdapter,
} from 'src/ui';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import { PHONE_MASK } from 'src/ui/const';
import { STATES } from '../const';

export function FISettingsEditPage({
  onSubmit,
  submitting,
  hasValidationErrors,
  isDirty,
  isExpanded,
  // settings,
}) {
  const [confirmChangesModal, setConfirmChangesModal] = useState(false);
  const toastContainerClassName = classNames('bottom-toast-container', {
    'is-condensed': !isExpanded,
  });

  function showModal() {
    setConfirmChangesModal(true);
  }
  function hideModal() {
    setConfirmChangesModal(false);
  }

  return (
    <Card tag="form" onSubmit={onSubmit} noValidate>
      <CardContent>
        <div className={toastContainerClassName}>
          <SaveChangesToast
            message="Click the button to the right to save your changes"
            isLoading={submitting}
            isDisabled={submitting || hasValidationErrors}
            isVisible={isDirty}
            // eslint-disable-next-line react/jsx-no-bind
            onClickButton={showModal}
          />
        </div>
        <ConfirmChangesModal
          title="FI Settings"
          isActive={confirmChangesModal}
          // eslint-disable-next-line react/jsx-no-bind
          onClickCancel={hideModal}
          // eslint-disable-next-line react/jsx-no-bind
          onClickSubmit={hideModal}
        />
        <InnerLoader visible={submitting} />
        <UiFieldset title="General Information" isFirst>
          <Columns>
            <Column isSize="1/3">
              <Field
                component={UiInputAdapter}
                name="fiDbaName"
                id="fiDbaName"
                label="DBA Name"
              />
            </Column>
            <Column isSize="1/3">
              <Field
                component={UiInputAdapter}
                name="fiTin"
                id="fiTin"
                label="Taxpayer Identification Number"
              />
            </Column>
            <Column isSize="1/3">
              <Field
                component={UiInputAdapter}
                name="fiFilingInstitutionId"
                id="fiFilingInstitutionId"
                label="Filing Institution Id"
              />
            </Column>
          </Columns>
          <Columns>
            <Column isSize="1/4">
              <Field
                component={UiInputAdapter}
                name="fiPhoneNumber"
                id="fiPhoneNumber"
                label="Phone Number"
                mask={PHONE_MASK}
              />
            </Column>
            <Column isSize="1/4">
              <Field
                component={UiInputAdapter}
                name="fiEmailAddress"
                id="fiEmailAddress"
                label="Email"
              />
            </Column>
            <Column isSize="1/4">
              <Field
                component={UiInputAdapter}
                name="fiWebsite"
                id="fiWebsite"
                label="Website"
              />
            </Column>
            <Column isSize="1/4">
              <Field
                component={UiSelectAdapter}
                name="fiRegisteredState"
                id="fiRegisteredState"
                label="Registered State"
                options={STATES}
                defaultValue={STATES[0]}
              />
            </Column>
          </Columns>
          <Columns>
            <Column isSize="full">
              <Field
                component={UiQuillAdapter}
                name="fiRestrictedWords"
                id="fiRestrictedWords"
                label="Restricted Words"
                placeholder="Please provide restricted words comma separated with no spaces"
              />
            </Column>
          </Columns>
          <Columns>
            <Column isSize="full">
              <Field
                component={UiQuillAdapter}
                name="fiMediaCheckEmails"
                id="fiMediaCheckEmails"
                label="Media Check Emails"
                placeholder="Please provide email addresses comma separated with no spaces"
              />
            </Column>
          </Columns>
        </UiFieldset>
        <UiFieldset title="Support Contact Information" isFirst>
          <Columns>
            <Column isSize="1/4">
              <Field
                component={UiInputAdapter}
                name="fiSupportName"
                id="fiSupportName"
                label="Support Contact Name"
              />
            </Column>
            <Column isSize="1/4">
              <Field
                component={UiInputAdapter}
                name="fiSupportTitle"
                id="fiSupportTitle"
                label="Support Contact Title"
              />
            </Column>
            <Column isSize="1/4">
              <Field
                component={UiInputAdapter}
                name="fiSupportEmail"
                id="fiSupportEmail"
                label="Support Contact Email"
              />
            </Column>
            <Column isSize="1/4">
              <Field
                component={UiInputAdapter}
                name="fiSupportPhone"
                id="fiSupportPhone"
                label="Support Contact Phone Number"
                mask={PHONE_MASK}
              />
            </Column>
          </Columns>
        </UiFieldset>
        <UiFieldset title="Primary Address" isFirst>
          <Columns>
            <Column isSize="1/2">
              <Field
                component={UiInputAdapter}
                name="fiPrimaryAddress"
                id="fiPrimaryAddress"
                label="Primary Street Address"
              />
            </Column>
            <Column isSize="1/2">
              <Field
                component={UiInputAdapter}
                name="fiPrimaryAddress2"
                id="fiPrimaryAddress2"
                label="Primary Street Address 2"
              />
            </Column>
          </Columns>
          <Columns>
            <Column isSize="1/3">
              <Field
                component={UiInputAdapter}
                name="fiPrimaryCity"
                id="fiPrimaryCity"
                label="Primary City"
              />
            </Column>
            <Column isSize="1/3">
              <Field
                component={UiInputAdapter}
                name="fiPrimaryState"
                id="fiPrimaryState"
                label="Primary State"
              />
            </Column>
            <Column isSize="1/3">
              <Field
                component={UiInputAdapter}
                name="fiPrimaryZipcode"
                id="fiPrimaryZipcode"
                label="Primary Zipcode"
              />
            </Column>
          </Columns>
        </UiFieldset>
        <UiFieldset title="Mailing Address" isFirst>
          <Columns>
            <Column isSize="1/2">
              <Field
                component={UiInputAdapter}
                name="fiMailingAddress"
                id="fiMailingAddress"
                label="Mailing Street Address"
              />
            </Column>
            <Column isSize="1/2">
              <Field
                component={UiInputAdapter}
                name="fiMailingAddress2"
                id="fiMailingAddress2"
                label="Mailing Street Address 2"
              />
            </Column>
          </Columns>
          <Columns>
            <Column isSize="1/3">
              <Field
                component={UiInputAdapter}
                name="fiMailingCity"
                id="fiMailingCity"
                label="Mailing City"
              />
            </Column>
            <Column isSize="1/3">
              <Field
                component={UiInputAdapter}
                name="fiMailingState"
                id="fiMailingState"
                label="Mailing State"
              />
            </Column>
            <Column isSize="1/3">
              <Field
                component={UiInputAdapter}
                name="fiMailingZipcode"
                id="fiMailingZipcode"
                label="Mailing Zipcode"
              />
            </Column>
          </Columns>
        </UiFieldset>
        <UiFieldset title="Templates - If blank default will be used">
          <Columns>
            <Column isSize="1/4">
              <Field
                component={UiInputAdapter}
                name="fiInviteEmail"
                id="fiInviteEmail"
                label="From Email Address"
              />
            </Column>
          </Columns>
          <Columns>
            <Column isSize="full">
              <Field
                component={UiQuillAdapter}
                name="fiAdminInvite"
                id="fiAdminInvite"
                label="FI Admin Invite Email Template"
                placeholder="Please provide the email template you would like to use for FI Admins invites. You may use {fi} and {name} as variables"
              />
            </Column>
          </Columns>
          <Columns>
            <Column isSize="full">
              <Field
                component={UiQuillAdapter}
                name="fiPaymentAccountInvite"
                id="fiPaymentAccountInvite"
                label="New Payments Account Email Template"
                placeholder="Please provide the email template you would like to be sent to the owner of a newly created payment account. You may use {fi} and {name} as variables"
              />
            </Column>
          </Columns>
          <Columns>
            <Column isSize="full">
              <Field
                component={UiQuillAdapter}
                name="fiPaymentAccountPersonInvite"
                id="fiPaymentAccountPersonInvite"
                label="Payment Account Person Invite"
                placeholder="Please provide the email template you would like to be sent when a new person is invited to a payment account. You may use {fi} and {name} as variables"
              />
            </Column>
          </Columns>
        </UiFieldset>

        <UiFieldset title="SAR Contact Information">
          <Columns>
            <Column isSize="1/3">
              <Field
                component={UiInputAdapter}
                name="fiSarContactOffice"
                id="fiSarContactOffice"
                label="Sar Contact Office"
              />
            </Column>
            <Column isSize="1/3">
              <Field
                component={UiInputAdapter}
                name="fiSarContactPhone"
                id="fiSarContactPhone"
                label="SAR Contact Phone Number"
                mask={PHONE_MASK}
              />
            </Column>
          </Columns>
        </UiFieldset>
        <UiFieldset title="Application Settings">
          <Columns>
            <Column isSize="1/2">
              <Field
                component={UiToggleAdapter}
                name="fiAssignAdminsToAccounts"
                id="fiAssignAdminsToAccounts"
                type="checkbox"
              >
                Manually Assign Admins to Accounts
              </Field>
            </Column>
          </Columns>
        </UiFieldset>
      </CardContent>
    </Card>
  );
}

FISettingsEditPage.propTypes = {
  // settings: propTypes.object.isRequired,
  onSubmit: propTypes.func.isRequired,
  submitting: propTypes.bool.isRequired,
  hasValidationErrors: propTypes.bool.isRequired,
  isDirty: propTypes.bool.isRequired,
  isExpanded: propTypes.bool.isRequired,
};
